import type { Notification } from '@baby-tracker/contracts';
import type { ReactElement } from 'react';

import { Button } from '../../ui/Button.js';
import { Card } from '../../ui/Card.js';
import styles from '../insights/insights.module.css';

export function NotificationList({
    items,
    pending,
    onRead,
    onDisable,
}: {
    items: Notification[];
    pending: boolean;
    onRead: (id: string) => void;
    onDisable?: ((notificationId: string, reminderId: string) => void) | undefined;
}): ReactElement | null {
    const unread = items.filter((item) => item.readAt === null);
    if (unread.length === 0) {
        return null;
    }
    return (
        <Card title="Due reminders" headingLevel={2}>
            <ul className={styles.list}>
                {unread.map((item) => (
                    <li key={item.id} className={styles.notice}>
                        <p className={styles.statValue}>{item.title}</p>
                        <p className={styles.meta}>{item.body}</p>
                        <div className={styles.actions}>
                            <Button
                                variant="secondary"
                                loading={pending}
                                onClick={() => {
                                    onRead(item.id);
                                }}
                            >
                                Mark done
                            </Button>
                            {item.reminderId !== null && onDisable !== undefined ? (
                                <Button
                                    variant="ghost"
                                    disabled={pending}
                                    onClick={() => {
                                        if (item.reminderId !== null) {
                                            onDisable(item.id, item.reminderId);
                                        }
                                    }}
                                >
                                    Turn off
                                </Button>
                            ) : null}
                        </div>
                    </li>
                ))}
            </ul>
        </Card>
    );
}
